import {__} from '@wordpress/i18n';
import {InspectorControls} from '@wordpress/block-editor';
import {
    PanelBody,
    ToggleControl,
    ColorPicker,
    Modal,
    Button,
    Dropdown,
} from '@wordpress/components';
import {useState, useEffect} from '@wordpress/element';
import { title } from '@wordpress/icons';

const inspector = ({attributes, setAttributes}) => {
    const {
        isLink,
        openNewTab,
        color,
        fontSize,
    } = attributes;

    return (
        <>
            <InspectorControls>
                <PanelBody title={__('Settings', 'realpress')} initialOpen={true}>
                    <ToggleControl
                        label={__('Make title a link', 'realpress')}
                        checked={isLink}
                        onChange={() => setAttributes({isLink: !isLink})}
                    />

                    {isLink && (
                        <ToggleControl
                            label={__('Open link in a new tab', 'realpress')}
                            checked={openNewTab}
                            onChange={() => setAttributes({openNewTab: !openNewTab})}
                        />
                    )}

                    <Dropdown
                        className="my-container-class-name"
                        contentClassName="my-popover-content-classname"
                        position="bottom center"
                        renderToggle={ ( { isOpen, onToggle } ) => (
                            <p
                                onClick={ onToggle }
                                aria-expanded={ isOpen }
                            >
                                <span>Color  </span>
                                <span style={{display: "inline-block", background: color, width: "20px", height: "20px", borderRadius: "50%", paddingLeft: "10px", border: "1px solid black"}}></span>
                            </p>
                        ) }
                        renderContent={ () => (
                            <ColorPicker
                                label={__('Color', 'realpress')}
                                value={color}
                                onChange={(value) => setAttributes({color: value})}/>
                        ) }
                    />
                </PanelBody>
            </InspectorControls>
        </>
    );
};

export default inspector;
